/* eslint-disable id-length */
const DialogSkeleton = () => (
  <div className="cr-skeleton">
    {/* Info row */}
    <div className="cr-skeleton__info-row">
      <div className="cr-skeleton__bar" />
      <div className="cr-skeleton__bar" />
    </div>

    <div className="cr-skeleton__divider" />

    {/* Row 1: CR Name, Description, Remarks — 3 cols */}
    <div className="cr-skeleton__row">
      {[1, 2, 3].map((i) => (
        <div key={i} className="cr-skeleton__field">
          <div className="cr-skeleton__label" />
          <div className="cr-skeleton__input" />
        </div>
      ))}
    </div>

    {/* Row 2: Efforts Investment, Customer Approval — 2 cols */}
    <div className="cr-skeleton__row cr-skeleton__row--half">
      {[1, 2].map((i) => (
        <div key={i} className="cr-skeleton__field">
          <div className="cr-skeleton__label" />
          <div className="cr-skeleton__input" />
        </div>
      ))}
    </div>

    <div className="cr-skeleton__divider" />
    <div className="cr-skeleton__bar cr-skeleton__bar--section-title" />

    {/* Effort table header */}
    <div className="cr-skeleton__effort-header">
      {[1, 2, 3, 4].map((i) => (
        <div key={i} className="cr-skeleton__bar" />
      ))}
    </div>

    {/* 2 skeleton effort rows */}
    {[1, 2].map((i) => (
      <div key={i} className="cr-skeleton__effort-row">
        {[1, 2, 3, 4].map((j) => (
          <div key={j} className="cr-skeleton__input" />
        ))}
      </div>
    ))}

    {/* Footer buttons */}
    <div className="cr-skeleton__footer">
      <div className="cr-skeleton__btn cr-skeleton__btn--cancel" />
      <div className="cr-skeleton__btn cr-skeleton__btn--save" />
    </div>
  </div>
);

export default DialogSkeleton;
